import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from './../../../_services/common.service';
import { HttpRequestService } from './../../../_services/http-request.service';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { EncrDecrService } from './../../../_services/encr-decr.service';
import { Router } from '@angular/router';
import { parse } from 'querystring';
@Component({
	selector: 'app-order-preview',
	templateUrl: './order-preview.component.html',
	styleUrls: ['./order-preview.component.scss']
})
export class OrderPreviewComponent implements OnInit {
	public shipmentCharge:any;
	constructor(public translate: TranslateService, private cService: CommonService,
		private httpService: HttpRequestService, private toastr: ToastrService,
		private formBuilder: FormBuilder, private EncrDecr: EncrDecrService,
		private router: Router) {
		this.cService.activelang.subscribe((lang) => {

			// this language will be used as a fallback when a translation isn't found in the current language
			translate.setDefaultLang(lang);

			// the lang to use, if the lang isn't available, it will use the current loader to get them
			translate.use(lang);
		});
	}

	orderDetails: any = {
		"itemlist": [],
		"total": 0,
		"shippingBilling": {},
		"coupon_code": "",
		"coupon_id": "",
		"discount_amount": 0,
		"net_payable_amount": 0
	};
	ngOnInit() {
		let userDetails = this.cService.getLoginUserDetails();
		this.httpService.setModule('action').post('order_preview', {
			user_id: userDetails.id,
			shopping_address_id:localStorage.getItem('_current_shipping')
		}).subscribe((response) => {

			//console.log(response);
			if (response.status == 'success') {

				if(response.data.hasAramexError && response.data.hasAramexError==true){
					this.toastr.error(response.data.aramexErrorMessage, 'Error:');
					this.router.navigate(['/order', 'billing']);
				}else{
					this.orderDetails.itemlist = response.data.bookData.map((cartItem) => {
						return {
							"id": cartItem.cartData.id,
							"item_id": cartItem.item_details.id,
							"item_type": cartItem.cartData.item_type,
							"item_name": cartItem.item_details.local[0].title,
							"item_image": cartItem.item_details.media[0].media_value,
							"slug": cartItem.item_details.slug,
							"product_no": cartItem.item_details.product_no,
							"item_count": Number(cartItem.cartData.item_count),
							"price": (cartItem.cartData.item_type == 'EB') ? cartItem.cartData.item_count * cartItem.item_details.e_book_price : cartItem.cartData.item_count * cartItem.item_details.list_price

						};
					});
					this.orderDetails.total = this.orderDetails.itemlist.map((cartItem) => {
						// console.log(cartItem);
						return cartItem.price;
					}).reduce((a, b) => a + b, 0);
					this.orderDetails.total = parseFloat(this.orderDetails.total).toFixed(2);
					this.shipmentCharge = response.data.shipping_amount;
					this.orderDetails.total = parseFloat(this.orderDetails.total)  + parseFloat(this.shipmentCharge);
					// console.log(this.orderDetails.shippingBilling,"orderDetails");
				}

			} else if (response.status == 'error') {
				this.toastr.error(response.message, 'Error:');
			}
		});
		if(localStorage.getItem('_current_shipping')){
			this.httpService.setModule('action').post('shipping_billing_address_details', {
				address_id: localStorage.getItem('_current_shipping')
			}).subscribe((response) => {
				if (response.status == 'success') {
					this.orderDetails.shippingBilling = response.data;
				}
				else if (response.status == 'error') {
					this.toastr.error(response.message, 'Error:');
				}
			});
		} else {
			this.orderDetails.shippingBilling = '';
		}
	}

	applyCoupon() {
		if (this.orderDetails.coupon_code) {
			this.httpService.setModule('action').post('apply_coupon', {
				"code": this.orderDetails.coupon_code,
				"total_cart_amount": this.orderDetails.total
			}).subscribe((response) => {
				if (response.status == 'success') {
					this.orderDetails.coupon_id = response.data.id;
					this.orderDetails.discount_amount = response.data.discount_amount;
					this.orderDetails.net_payable_amount = response.data.net_payable_amount;
					this.translate.get(['COUPON_APPLIED_MSG']).subscribe((tData) => {
						this.toastr.success(tData['COUPON_APPLIED_MSG'], 'Success:');
					})
				}
				else if (response.status == 'error') {
					this.toastr.error(response.data, 'Error:');
				}
			});
		}
	}
	removeCoupon() {
		this.orderDetails.coupon_id = "";
		this.orderDetails.coupon_code = "";
		this.orderDetails.discount_amount = 0;
		this.orderDetails.net_payable_amount = 0;
	}

	// goToPayment() {
	// 	this.translate.get([
	// 		"HEY",
	// 		"CART_BEFORE_PAYMENT_WARNING",
	// 		"NO",
	// 		"YES"
	// 	]).subscribe((tData) => {
	// 		Swal.fire({
	// 			'title': tData['HEY'],
	// 			'text': tData['CART_BEFORE_PAYMENT_WARNING'],
	// 			'type': 'warning',
	// 			'showCancelButton': true,
	// 			'confirmButtonText': tData["YES"],
	// 			'confirmButtonColor':"#06978a",
	// 			'cancelButtonText': tData["NO"],
	// 			'cancelButtonColor':"#d33"
	// 		}).then((result)=>{
	// 			if(result.value){
	// 				let newOrderRecord = {
	// 					'address': localStorage.getItem('_current_shipping'),
	// 					'price': (this.orderDetails.net_payable_amount == 0) ? this.orderDetails.total : this.orderDetails.net_payable_amount,
	// 					'discount_price': this.orderDetails.discount_amount,
	// 					'coupon_id': this.orderDetails.coupon_id,
	// 					'shipping_amount':this.shipmentCharge
	// 				};
	// 				let orderDetails = sessionStorage.getItem('_corder');
	// 				if (orderDetails) {
	// 					orderDetails = JSON.parse(this.EncrDecr.get(orderDetails));
	// 					newOrderRecord["id"] = orderDetails["id"];
	// 				}
	// 				let orderSummeryData = this.EncrDecr.set(JSON.stringify(newOrderRecord));
	// 				sessionStorage.setItem('_corder', orderSummeryData);
	// 				sessionStorage.removeItem('_testOrTrainingOrderData');
	// 				sessionStorage.removeItem('_eventOrderData');
	// 				//this.router.navigate(['/order', 'payment']);
	// 				this.router.navigate([]).then(result => {  window.open('/order/payment', '_blank'); });
	// 			}

	// 		})
	// 	});

	// }

	goToPayment() {
		this.translate.get([
			"HEY",
			"CART_BEFORE_PAYMENT_WARNING",
			"NO",
			"YES"
		]).subscribe((tData) => {
			Swal.fire({
				'title': tData['HEY'],
				'text': tData['CART_BEFORE_PAYMENT_WARNING'],
				'type': 'warning',
				'showCancelButton': true,
				'confirmButtonText': tData["YES"],
				'confirmButtonColor':"#06978a",
				'cancelButtonText': tData["NO"],
				'cancelButtonColor':"#d33"
			}).then((result)=>{
				if(result.value){
					let newOrderRecord = {
						'address': localStorage.getItem('_current_shipping'),
						'price': (this.orderDetails.net_payable_amount == 0) ? this.orderDetails.total : this.orderDetails.net_payable_amount,
						'discount_price': this.orderDetails.discount_amount,
						'coupon_id': this.orderDetails.coupon_id,
						'shipping_amount':this.shipmentCharge
					};
					let orderDetails = sessionStorage.getItem('_corder');
					if (orderDetails) {
						orderDetails = JSON.parse(this.EncrDecr.get(orderDetails));
						newOrderRecord["id"] = orderDetails["id"];
					}
					let orderSummeryData = this.EncrDecr.set(JSON.stringify(newOrderRecord));
					sessionStorage.setItem('_corder', orderSummeryData);
					sessionStorage.removeItem('_testOrTrainingOrderData');
					sessionStorage.removeItem('_eventOrderData');
					this.router.navigate(['/order', 'payment']);
				}

			})
		});

	}
}
